import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { addPersonalLoadOwner, setIsSearchCompany, setSearchCompany } from '../../features/isOrtaklari/isOrtaklariSlice'
import InputText from '../shared/input/new/InputText'
import InputPhoneFormat from '../shared/input/new/InputPhoneFormat'
import InputMail from '../shared/input/new/InputMail'
import { showModal } from '../../features/modal/modalSlice'
import styled from 'styled-components'
import Btn from '../shared/button/Btn'
import InputNumberNew from '../shared/input/new/InputNumberNew'
import SmallSpinner from '../shared/spinners/SmallSpinner'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  .project-info{
    p{
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-lg);
    }
  }
  .btn-container{
    display: flex;
    align-items: center;
    gap: 15px;
    justify-content: center;
  }
`

const AddNewLoadGiver = () => {
  const dispatch = useDispatch()
  const { getIsLoading } = useSelector(state => state.isOrtaklari)
  const [isSubmit, setIsSubmit] = useState(false)

  const [phoneValue, setPhoneValue] = useState("")

  const [kayitData, setKayitData] = useState({
      yetkiliUsername:"",
      yetkiliMail:"",
      yetkiliPhoneNumber:"",
      vergiNo:"",
      firmaName:"",
      password: "",
      passwordAgain:"",
      projectName: ""
  })

  const handleSubmit = () => {
      setIsSubmit(true)
      if(kayitData?.yetkiliUsername, kayitData?.yetkiliMail, kayitData?.yetkiliPhoneNumber, kayitData?.vergiNo, kayitData?.firmaName, kayitData?.projectName){
          const addData = {
              yetkiliUserName: kayitData?.yetkiliUsername,
              yetkiliMail: kayitData?.yetkiliMail,
              yetkiliPhoneNumber: kayitData?.yetkiliPhoneNumber?.slice(2),
              firmaName: kayitData?.firmaName,
              vergiNo: kayitData?.vergiNo,
              projectName: kayitData?.projectName
          }
          dispatch(addPersonalLoadOwner(addData))
          
      }
  }

  const handleChange = ({e, type}) => {
      if(type === "number"){
          setKayitData((prev) => ({...prev, [e.target.name]: e.target.value.replace(/[^0-9]/g, '')}))
      }
      else{
          setKayitData((prev) => ({...prev, [e.target.name]: e.target.value}))
      }
  }

return (
  <Container>
    <div className="project-info">
      <p>Aşağıdaki bilgileri; ilgili firmadan teyit alarak, hatasız ve eksiksiz olarak giriniz.</p>
    </div>
    
    <div className="input-grp">
      <InputText data={kayitData.yetkiliUsername} setData={(e) => handleChange({e, type: ""})} labelText="Yetkili Adı Soyadı" inputWidth={"100%"} name={"yetkiliUsername"}/>
        {isSubmit && !kayitData.yetkiliUsername &&
            <span className="error">Yetkili adı ve soyadını giriniz.</span>
        }
    </div>
    
    <div className="input-grp">
        <InputMail data={kayitData.yetkiliMail} setData={(e) => handleChange({e, type: ""})} labelText="Yetkili Mail Adresi" inputWidth={"100%"} name={"yetkiliMail"}/>
        {isSubmit && !kayitData.yetkiliMail &&
            <span className="error">Yetkili mailini giriniz.</span>
        }
    </div>
    
    <div className="input-grp">
        <InputPhoneFormat data={phoneValue} setData={setPhoneValue} labelText="Yetkili Telefonu" inputWidth={"100%"} name={"yetkiliPhoneNumber"}/>
        {isSubmit && !phoneValue &&
            <span className="error">Yetkili telefon numarasını giriniz.</span>
        }
    </div>
    
    <div className="input-grp">
        <InputNumberNew max={11} data={kayitData.vergiNo} setData={(e) => handleChange({e, type: "number"})} labelText="Firma/Koop. Vergi No" inputWidth={"100%"} name={"vergiNo"}/>
        {isSubmit && !kayitData.vergiNo &&
            <span className="error">Vergi numarasını giriniz.</span>
        }
    </div>
    
    <div className="input-grp">
        <InputText auto={"off"} data={kayitData.firmaName} setData={(e) => handleChange({e, type: ""})} labelText="Firma/Koop. Adı/Ünvanı" inputWidth={"100%"} name={"firmaName"}/>
        {isSubmit && !kayitData.firmaName &&
            <span className="error">Firma adını giriniz.</span>
        }
    </div>

    <div className="input-grp">
        <InputText data={kayitData.projectName} setData={(e) => handleChange({e, type: ""})} labelText="Proje İsmi" inputWidth={"100%"} name={"projectName"}/>
        {isSubmit && !kayitData.projectName &&
            <span className="error">Yetkili adı ve soyadını giriniz.</span>
        }
    </div>
    
    <div className="btn-container">
        <Btn width="150px" handleClick={handleSubmit} padding="10px" background="#fff" color={"#E85446"}>{getIsLoading ? <SmallSpinner size={"20px"} color={"#E85446"} bgColor={"#fff"}/> : "Kaydet"}</Btn>
        <Btn width="150px" handleClick={() => {dispatch(showModal(null)); dispatch(setSearchCompany(null)); dispatch(setIsSearchCompany(false))}} padding="10px" background="#fff" color={"#E85446"}>Kapat</Btn>
    </div>
  </Container>
)
}

export default AddNewLoadGiver